module.exports = __webpack_public_path__ + "static/media/Rayyan.f8724987.JPG";